export default __webpack_public_path__ + "static/media/team-3.89cb5395.png";